import { message, Button, Row, Col, Typography, Modal } from "antd";
import {
  CloseCircleOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const { Text } = Typography;


export function errorMessageOld(text: string) {
  const key = Math.random();
  return message.error({
    icon: (
      <Row justify="end">
        <Col span={3}>
          <Button id='error' type="link" onClick={() => message.destroy(key)}>
            <CloseOutlined />
          </Button>
        </Col>
      </Row>
    ),
    key: key,
    content: (
      <Row justify="end">
        <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
          <Row justify="center">
            <CloseCircleOutlined />
            <Text>{text}</Text>
          </Row>
        </Col>
      </Row>
    ),
    duration: 5,
    className: "custom-class",
  });
}

export function successMessageOld(text: string) {
  const key = Math.random();
  return message.success({
    icon: (
      <Row justify="end">
        <Col span={3}>
          <Button id='success' type="link" onClick={() => message.destroy(key)}>
            <CloseOutlined />
          </Button>
        </Col>
      </Row>
    ),
    key: key,
    content: (
      <Row justify="end">
        <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
          <Row justify="center">
            <CheckCircleOutlined />
            <Text>{text}</Text>
          </Row>
        </Col>
      </Row>
    ),
    duration: 5,
    className: "custom-class",
  });
}


export function infoMessageOld(text: string) {
  const key = Math.random();

  return message.info({
    icon: (
      <Row justify="end">
        <Col span={3}>
          <Button id='info' type="link" onClick={() => message.destroy(key)}>
            <CloseOutlined />
          </Button>
        </Col>
      </Row>
    ),
    key: key,
    content: (
      <Row justify="end">
        <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
          <Row justify="center">
            <InfoCircleOutlined />
            <Text>{text}</Text>
          </Row>
        </Col>
      </Row>
    ),
    duration: 5,
    className: "custom-class",
  });
}


import {
  EyeOutlined,
} from "@ant-design/icons";

import type { IErroApi, Detail, Campos } from "../services/api";


export function errorMessage(text: string) {
  return message.error({
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

export function successMessage(text: string) {
  return message.success({
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

export function infoMessage(text: string) {
  const key = Math.random();

  return message.info({
    key: key,
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

const { info } = Modal;

export function mostrarInfo(title: string, msg: string) {
  info({
    title: title,
    width: "400px",
    icon: <EyeOutlined />,
    content: msg,
  });
}

export function mostrarInfoDetail(title: string, erroApi: IErroApi) {
  let msg = erroApi.mensagem;

  const details: Detail[] = erroApi.details;
  const campos: Campos[] = erroApi.campos;

  if ((!details || details.length === 0) && (!campos || campos.length === 0)) {
    info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content: msg
    });
    return
  }

  if (details && details.length > 0) {
    info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content:
        <div>
          {msg}
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {details.map((detail, index) => (
              <li key={index}>{detail.errors[0] !== "" ? "Cod.: " + detail.errors[0] + " - " : ""}  {detail.defaultMessage}</li>
            ))}
          </ul>
        </div>
    });
    return
  }

  if (campos && campos.length > 0) {
    info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content:
        <div>
          {msg}
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {campos.map((campo, index) => (
              <li key={index}>Campo: {campo.cnome} - {campo.cmensagem}</li>
            ))}
          </ul>
        </div>
    });
  }
}
